/**
 * Mutación para setear los procesos de seguridad.
 *
 */

export function setProcessSecurity(state, processSecurity) {
    state.processSecurity = processSecurity;
}

/**
 * Mutación para actualizar los procesos de seguridad.
 *
 */
export function updateFilter(state,type) {
    state.processSecurity = [];
    state.filter.type = type;
}


/**
 * Set detalle info
 *
 */
export function setDetails(state,procesDetails) {
    state.procesDetails = procesDetails;
}


/**
 * Set detalle info
 *
 */
export function setDetailsPreventionPolicy(state,procesDetailsPrePol) {
    state.procesDetailsPrePol = procesDetailsPrePol;
}



/**
 * Mutación para setear prevención de accidentes mayores.
 *
 */

export function setPrSecPreventionPolicy(state, preventionPolicies) {
    state.preventionPolicies = preventionPolicies;
}



/**
 * Mutación para setear adjuntos
 *
 */

export function setAttachments(state, attachments) {
    state.attachments = attachments;
}


/**
 * Cambiar el valor del currentType
 *
 */
export function changeCurrentType(state,currentType) {
    state.currentType = currentType;
}

/**
 * Agregar valores de la info para mostrar porcentaje.
 *
 */
export function setDataPercentage(state, dataPercentage) {
    state.dataPercentage = dataPercentage;
}


/**
 * Mutación para agregar las opciones
 *
 */
export function setOptionsTypes(state, options_types) {
    state.options_types = options_types;
}



/**
 * Eliminar del arreglo el parametro eliminado
 *
 */
export function deleteParameter(state,id) {
    const index = state.options_types.findIndex(item => item.id == id);
    state.options_types.splice(index,1);
}
